export enum BUTTON_CONTAINER_JUSTIFICATION {
	Fill = 'fill',
	Left = 'left',
	Right = 'right'
}
